var _rect, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClearIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 96,
    height: 96,
    fill: "url(#pattern0_6032_8846)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_6032_8846",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_6032_8846",
    transform: "scale(0.0104167)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_6032_8846",
    width: 96,
    height: 96,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGAAAABgCAYAAADimHc4AAAACXBIWXMAAAsTAAALEwEAmpwYAAAC80lEQVR4nO2czWoVQRCFDwqCitzgUvQJVEQEV+LGuHGnPoD4BvFBjCHoc+hW1L1ypTe6928tGY07lZKBCYjce72T6a4+NXM+qF2Snj6nM3RVVw8ghBBCCCGEEEIIIYQQQgjRnxMA7gN4AeATgF8AbELxA8B7ADsALngvoOsAPhOIYCTxG8ATAMc8xL87wdVua8ar0iZcBLBPMFEjjselxD8KYE4wQSOP9u1wvoQBWwSTsyCxnVv8swC+E0zMgsS73AY8JZiUBYp2sWbjFsGELGBk4SSADwSTsYCRhUcEE7GgMZhLAH4STMSCxiCOAHhd+AEbADcBvHEUJQG4AeAruwFbDuJf7caaOZnQin+6G/OygwmH5kwnkIf4cDLhb/HhZALlnr9ZIH5pExaJ72EC3Z6/WSF+KRNWiV/ahN6cKlzj31zzOTYyFf3m3d9ah00GA0rv+dMaqzHXf4LnWFkM8NrzJwdhGMQ3tj2/OQnEIr6x1/lTAaGYxDeWPb+XYIlMfItS508ZhGMU3yLV+dMAAVnFt2h1/nQIIZnFt4h1/nmPxGmj58/W6OYIWedPPVY168pfaYD3nr+mCbOK4lv03p400ITa4hvbnt8cTWAQ3xj3/OZgAov4Cw14RvBQNmUDzgVrL0xjewW1PBi5+EwmLG0xfzty8VlMWMoV4hsuaeyJ2AEqRaCuAe0B/JegK382hmJcy+3A4luG361uAENukKZ8IFM7N0g6kqyXGyQdytfLDZLaUurlBkmNWcvZGYH4VmGsZdEbNeeirgGlc4NG7en1c4NGFzTq5waNrijVzw0aXdKrnxvsdTdTPJum5t2Yew5jDYb53MACRBZK5wY24sgC27mBBYpssJwbWLDISu1zAwsW33IbEK2nyMb2ybJIPUVGEA9LGBChp8jG/NnKFn24Ff81YBeFuUN8w8Yqx0uv70df08e78e9rZ9dL/AOOA7gH4DmAjxMsW+x3u53tku98IYQQQgghhBBCCCGEEEIgDH8AoM+E3MXmz8kAAAAASUVORK5CYII="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClearIcon);
export default __webpack_public_path__ + "static/media/clear_icon.f8921142d50ab8b030659d32fc9c47cd.svg";
export { ForwardRef as ReactComponent };